const INITIAL_THEMES = [
  'fanduel-casino',
  'fanduel-poker',
  'fanduel-xsell',
  'mohegansun-casino',
  'mohegansun-xsell',
] as const;

export type Themes = (typeof INITIAL_THEMES)[number];

const getDefaultTheme = (): Themes => {
  const appInstance = process.env?.APPLICATION ?? 'fanduel-casino-usa';
  const [brand, product] = appInstance.split('-');
  const themeName = `${brand}-${product}` as Themes;
  if ((INITIAL_THEMES as readonly string[]).includes(themeName)) {
    return themeName as Themes;
  }
  return 'fanduel-casino' as Themes;
};

export const DEFAULT_THEME = getDefaultTheme();

export { INITIAL_THEMES };

export type ThemeSlice = {
  theme: Themes;
  themes: Themes[];
  addTheme: (name: string) => void;
  changeTheme: (name: string) => void;
  resetTheme: () => void;
};
